import * as Sentry from '@sentry/react'
import { scrubSentryEvent, sentryDataCollection } from '@repo/shared'

const dsn =
  import.meta.env.VITE_SENTRY_DSN ||
  (import.meta.env.PROD
    ? 'https://6ed76b4db102a6296d708760c733631b@o4512248584077312.ingest.us.sentry.io/4512249805996032'
    : undefined)
if (dsn) {
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    dataCollection: sentryDataCollection,
    tracePropagationTargets: [],
    beforeSendLog: () => null,
    beforeSendMetric: () => null,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    maxBreadcrumbs: 0,
    integrations: (defaults) =>
      defaults.filter((integration) =>
        /^(GlobalHandlers|BrowserApiErrors|InboundFilters|Dedupe|LinkedErrors)$/.test(
          integration.name,
        ),
      ),
    beforeSend: (event) => scrubSentryEvent(event, 'recipecat-admin'),
  })
}

export { Sentry }
